import { bindRequestLogic } from './utils'
import ElectronicKeyType from '../actionTypes/electronicKey'
import { electronicKeyAPI } from '../api'

const getElectronicKeys = bindRequestLogic({
  clientFunc: electronicKeyAPI.getElectronicKeys,
  type: ElectronicKeyType.GET_ELECTRONIC_KEYS_REQUEST,
  successType: ElectronicKeyType.GET_ELECTRONIC_KEYS_SUCCESS,
  failType: ElectronicKeyType.GET_ELECTRONIC_KEYS_FAILED,
  isQueryParam: true,
  modelName: 'electronicKey'
})

const addElectronicKey = bindRequestLogic({
  clientFunc: electronicKeyAPI.addElectronicKey,
  type: ElectronicKeyType.ADD_ELECTRONIC_KEY_REQUEST,
  successType: ElectronicKeyType.ADD_ELECTRONIC_KEY_SUCCESS,
  failType: ElectronicKeyType.ADD_ELECTRONIC_KEY_FAILED
})

const getElectronicKeyDetail = bindRequestLogic({
  clientFunc: electronicKeyAPI.getElectronicKeyDetail,
  type: ElectronicKeyType.GET_ELECTRONIC_KEY_DETAIL_REQUEST,
  successType: ElectronicKeyType.GET_ELECTRONIC_KEY_DETAIL_SUCCESS,
  failType: ElectronicKeyType.GET_ELECTRONIC_KEY_DETAIL_FAILED,
  modelName: 'electronicKey'
})

const deleteElectronicKey = bindRequestLogic({
  clientFunc: electronicKeyAPI.deleteElectronicKey,
  type: ElectronicKeyType.DELETE_ELECTRONIC_KEY_REQUEST,
  successType: ElectronicKeyType.DELETE_ELECTRONIC_KEY_SUCCESS,
  failType: ElectronicKeyType.DELETE_ELECTRONIC_KEY_FAILED
})

const updateElectronicKey = bindRequestLogic({
  clientFunc: electronicKeyAPI.updateElectronicKey,
  type: ElectronicKeyType.UPDATE_ELECTRONIC_KEY_REQUEST,
  successType: ElectronicKeyType.UPDATE_ELECTRONIC_KEY_SUCCESS,
  failType: ElectronicKeyType.UPDATE_ELECTRONIC_KEY_FAILED
})

const getSheetVehicles = bindRequestLogic({
  clientFunc: electronicKeyAPI.getSheetVehicle,
  type: ElectronicKeyType.GET_SHEET_VEHICLE_ELECTRONIC_KEYS_REQUEST,
  successType: ElectronicKeyType.GET_SHEET_VEHICLE_ELECTRONIC_KEYS_SUCCESS,
  failType: ElectronicKeyType.GET_SHEET_VEHICLE_ELECTRONIC_KEYS_FAILED,
  isQueryParam: true
})

const getSystemElectronicKeys = bindRequestLogic({
  clientFunc: electronicKeyAPI.getSystemElectronicKeys,
  type: ElectronicKeyType.GET_SYSTEM_ELECTRONIC_KEYS_REQUEST,
  successType: ElectronicKeyType.GET_SYSTEM_ELECTRONIC_KEYS_SUCCESS,
  failType: ElectronicKeyType.GET_SYSTEM_ELECTRONIC_KEYS_FAILED,
  isQueryParam: true
})

export default [
  getElectronicKeys,
  addElectronicKey,
  getElectronicKeyDetail,
  deleteElectronicKey,
  updateElectronicKey,
  getSheetVehicles,
  getSystemElectronicKeys
]
